module.exports = __webpack_public_path__ + "assets/img/wallpaper-95.0e2bae65.jpg";